import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";

import { GameFilters } from "@pages/casino/containers";
import {
	BettoCollectionContent,
	BettoCollectionPage,
} from "@pages/casino/pages/provider/bettoCollectionElements";

import { BettoFavoritesBrowse } from "./BettoFavoritesBrowse.jsx";
import useBettoFavoritesController from "./useBettoFavoritesController.js";

export const BettoFavoritesView = memo(({ translate, history, location }) => {
	const {
		state: { selectedFilters },
		handlers: { handleSelectFilter },
	} = useBettoFavoritesController({ loadFavorites: false });

	const handleFiltersToggle = useCallback(() => {}, []);

	return (
		<BettoCollectionPage>
			<BettoCollectionContent>
				<GameFilters
					onlySelectFilter={false}
					showLobbyFilter
					showCategoriesFilter
					showContainerCategories
					showProvidersFilter
					showSearch
					showAllGames
					showIFeelLucky
					showFavorites
					filterValues={selectedFilters}
					onSelectFilter={handleSelectFilter}
					onClose={handleFiltersToggle}
					activeTab="Casino"
					history={history}
					location={location}
				/>

				<BettoFavoritesBrowse
					translate={translate}
					history={history}
					location={location}
				/>
			</BettoCollectionContent>
		</BettoCollectionPage>
	);
});

BettoFavoritesView.displayName = "BettoFavoritesView";

BettoFavoritesView.propTypes = {
	translate: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};

export default BettoFavoritesView;
